// extracted by mini-css-extract-plugin
export default {"container":"Error_container__cRMi1","textError":"Error_textError__LqXfW"};